"use client";

import { Button } from "@mui/material";
import { useAssignDialog } from "../Providers/AssignDialogContext";

export default function CancelButton() {
  const { closeAssignDialog } = useAssignDialog();

  const handleCancel = () => {
    closeAssignDialog();
  };

  return (
    <Button onClick={handleCancel} type="button" size="medium" variant="text">
      Cancel
    </Button>
  );
}
